<div class="analytics-page-component">
  <kehe-phoenix-alert-layout>
    @if (banner$ | async; as banner) {
      <kehe-phoenix-alert
        [type]="banner.type"
        [message]="banner.message"
        [hideCloseIcon]="true"
        stick="true"
        [show]="true"
      >
      </kehe-phoenix-alert>
    }
  </kehe-phoenix-alert-layout>

  @if (showDashboard) {
    <kehe-phoenix-manage-list-page-title-layout pageTitle="Analytics">
      <ng-template #actionsBlock>
        <!-- Help Button + Modal -->
        <kehe-phoenix-help-button-modal-block
          [videos]="helpVideos"
          [faqs]="faqs"
        ></kehe-phoenix-help-button-modal-block>
      </ng-template>
    </kehe-phoenix-manage-list-page-title-layout>

    <app-report
      [url]="dashboardUrl"
      [token]="userToken$ | async"
      [height]="dashboardHeight"
    >
    </app-report>
  }

  <div class="dashboard">
    <div class="d-flex justify-content-between"></div>
    @if (!showDashboard) {
      <app-unauthorized-page></app-unauthorized-page>
    }
  </div>
</div>
